import { Globe, Moon, Sun } from 'lucide-react'
import { useI18n } from '../i18n/index.tsx'
import { useTheme } from '../theme/ThemeProvider.tsx'

export function Header() {
  const { lang, setLang, t } = useI18n()
  const { theme, toggleTheme } = useTheme()

  return (
    <header className="w-full bg-background border-b border-border">
      <div className="max-w-4xl mx-auto px-4 h-14 flex items-center justify-between">
        <a href="https://cikastudio.com" className="flex items-center gap-2 text-primary hover:opacity-80 transition-opacity">
          <span className="font-semibold text-foreground text-lg tracking-tight">CikaStudio</span>
        </a>
        <div className="flex items-center gap-2">
          <nav className="hidden md:flex items-center gap-4 text-sm text-muted-foreground mr-4">
            <a href="https://tools.cikastudio.com?v=2" className="hover:text-foreground transition-colors">{t('header.tools')}</a>
            <a href="https://games.cikastudio.com" className="hover:text-foreground transition-colors">{t('header.games')}</a>
            <a href="https://tools.cikastudio.com/about?v=2" className="hover:text-foreground transition-colors">{t('header.about')}</a>
          </nav>
          
          {/* Language Switcher */}
          <button
            onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
            className="flex items-center gap-1 px-2 py-1.5 text-xs text-foreground rounded-md border border-border hover:bg-muted transition-colors"
            title={lang === 'en' ? 'Switch to 中文' : 'Switch to English'}
          >
            <Globe className="w-3.5 h-3.5" />
            <span>{lang === 'en' ? 'EN' : '中文'}</span>
          </button>
          
          {/* Theme Toggle */}
          <button
            onClick={toggleTheme}
            className="flex items-center justify-center w-8 h-8 text-foreground rounded-md border border-border hover:bg-muted transition-colors"
            title={theme === 'light' ? t('theme.dark') : t('theme.light')}
          >
            {theme === 'light' ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
          </button>
        </div>
      </div>
    </header>
  )
}
